export default {"src":"/uk/_next/static/media/twoFAIcon.9fcbe6c1.svg","height":200,"width":200,"blurWidth":0,"blurHeight":0};